var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extra)?_c('div',[_c('h6',[_vm._v(_vm._s(_vm.title)+" "+_vm._s(_vm.$store.getters.device(_vm.extra.serial)[_vm.extra.name])+" "+_vm._s(_vm.extra.unit))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }